import React from "react"
import Skeleton from "react-loading-skeleton"

function CardTeamSkeleton() {
  return (
    <div
      className="uk-card uk-card-default uk-grid-collapse uk-child-width-1-2"
      uk-grid="true"
    >
      <div className="uk-card-media-left">
        <Skeleton height={400} />
      </div>
      <div className="uk-width-expand">
        <div className="uk-card-body">
          <h3 className="uk-card-title">
            <Skeleton />
          </h3>
          <h5 className="uk-margin-small-top font-red">
            <Skeleton />
          </h5>
          <p className="uk-text-secondary uk-text-small">
            <Skeleton />
          </p>
          <p className="uk-text-secondary uk-text-small">
            <Skeleton />
          </p>
          <p className="uk-text-secondary uk-text-small">
            <Skeleton />
          </p>
        </div>
      </div>
    </div>
  )
}

export default CardTeamSkeleton
